"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatConfirmation = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
const utils_1 = require("@/utils");
/**
 * AI 툴 실행 승인 요청 UI.
 * status="pending"  → 승인/거부 버튼 표시
 * status="accepted" → 승인 완료 상태 표시
 * status="rejected" → 거부 완료 상태 표시
 */
let ChatConfirmation = class ChatConfirmation extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.status = 'pending';
        this.message = '';
    }
    render() {
        if (this.status === 'accepted') {
            return (0, lit_1.html) `
        <mm-notice variant="success" description="승인했습니다"></mm-notice>
      `;
        }
        if (this.status === 'rejected') {
            return (0, lit_1.html) `
        <mm-notice variant="error" description="거부했습니다"></mm-notice>
      `;
        }
        return (0, lit_1.html) `
      <mm-notice heading="승인 요청" description=${this.message}>
        <slot></slot>
        <mm-button-group>
          <mm-button variant="tertiary" size="medium" @click=${this.handleRejectClick}>
            거부
          </mm-button>
          <mm-button variant="tertiary" size="medium" @click=${this.handleApproveClick}>
            승인
          </mm-button>
        </mm-button-group>
      </mm-notice>
    `;
    }
    handleApproveClick() {
        this.status = 'accepted';
        (0, utils_1.emit)(this, 'confirmation-approve');
    }
    handleRejectClick() {
        this.status = 'rejected';
        (0, utils_1.emit)(this, 'confirmation-reject');
    }
};
ChatConfirmation.styles = (0, lit_1.css) `
    :host {
      display: block;
      max-width: min(85%, 480px);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatConfirmation.prototype, "status", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatConfirmation.prototype, "message", void 0);
ChatConfirmation = __decorate([
    (0, decorators_js_1.customElement)('mm-chat-confirmation')
], ChatConfirmation);
exports.ChatConfirmation = ChatConfirmation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhdC1jb25maXJtYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjaGF0LWNvbmZpcm1hdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQTJEO0FBRTNELCtCQUE0QjtBQUM1QixtQ0FBOEI7QUFJOUI7Ozs7O0dBS0c7QUFFSSxJQUFNLGdCQUFnQixHQUF0QixNQUFNLGdCQUFpQixTQUFRLGdCQUFVO0lBQXpDOztRQU91QixXQUFNLEdBQXVCLFNBQVMsQ0FBQTtRQUN0QyxZQUFPLEdBQUcsRUFBRSxDQUFBO0lBdUMxQyxDQUFDO0lBckNDLE1BQU07UUFDSixJQUFJLElBQUksQ0FBQyxNQUFNLEtBQUssVUFBVSxFQUFFO1lBQzlCLE9BQU8sSUFBQSxVQUFJLEVBQUE7O09BRVYsQ0FBQTtTQUNGO1FBRUQsSUFBSSxJQUFJLENBQUMsTUFBTSxLQUFLLFVBQVUsRUFBRTtZQUM5QixPQUFPLElBQUEsVUFBSSxFQUFBOztPQUVWLENBQUE7U0FDRjtRQUVELE9BQU8sSUFBQSxVQUFJLEVBQUE7K0NBQ2dDLElBQUksQ0FBQyxPQUFPOzs7K0RBR0ksSUFBSSxDQUFDLGlCQUFpQjs7OytEQUd0QixJQUFJLENBQUMsa0JBQWtCOzs7OztLQUtqRixDQUFBO0lBQ0gsQ0FBQztJQUVPLGtCQUFrQjtRQUN4QixJQUFJLENBQUMsTUFBTSxHQUFHLFVBQVUsQ0FBQTtRQUN4QixJQUFBLFlBQUksRUFBQyxJQUFJLEVBQUUsc0JBQXNCLENBQUMsQ0FBQTtJQUNwQyxDQUFDO0lBRU8saUJBQWlCO1FBQ3ZCLElBQUksQ0FBQyxNQUFNLEdBQUcsVUFBVSxDQUFBO1FBQ3hCLElBQUEsWUFBSSxFQUFDLElBQUksRUFBRSxxQkFBcUIsQ0FBQyxDQUFBO0lBQ25DLENBQUM7O0FBN0NNLHVCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7O0dBS2xCLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2dEQUF1QztBQUN0QztJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7aURBQWE7QUFSN0IsZ0JBQWdCO0lBRDVCLElBQUEsNkJBQWEsRUFBQyxzQkFBc0IsQ0FBQztHQUN6QixnQkFBZ0IsQ0ErQzVCO0FBL0NZLDRDQUFnQiJ9